// Escapa uma célula para CSV (aspas quando há separador, aspas ou quebra).
const escapeCell = (value: unknown): string => {
  const text = value === null || value === undefined ? "" : String(value);
  if (/[";\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
};

export const exportToCsv = (
  filename: string,
  headers: string[],
  rows: (string | number | null | undefined)[][]
): void => {
  const separator = ";"; // Excel pt-BR usa ";" como separador padrão.
  const lines = [headers, ...rows].map((row) =>
    row.map(escapeCell).join(separator)
  );
  // BOM (\uFEFF) garante acentuação correta ao abrir no Excel.
  const content = "\uFEFF" + lines.join("\r\n");
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
};
